import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginData: null,
  isLoggedIn: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.loginData = action.payload;
      state.isLoggedIn = !!action.payload;
    },
    clearUser(state) {
      state.loginData = null;
      state.isLoggedIn = false;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
